export const DEFAULT_EVENT_CATEGORY_COLOR = "#607d8b";

export const DEFAULT_EVENT_CATEGORY_COLORS = {
  "Local/Comercial": "#4caf50",
  Gastronómico: "#2196f3",
  Capacitación: "#ff9800",
  "Reunión interna": "#9c27b0",
  Administrativo: "#f44336",
  Otro: DEFAULT_EVENT_CATEGORY_COLOR,
};

export const DEFAULT_EVENT_CATEGORIES = Object.entries(
  DEFAULT_EVENT_CATEGORY_COLORS
).map(([name, color]) => ({ name, color }));

export function getDefaultEventCategoryColor(category) {
  return DEFAULT_EVENT_CATEGORY_COLORS[category] || DEFAULT_EVENT_CATEGORY_COLOR;
}
